export default "__VITE_PUBLIC_ASSET__6e699e00__"